import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import CardWrapper from "../../CardWrapper";
import Card from "../../Card";
import {
  getPharmGKBDrugs,
  getPharmGKBData,
} from "../../../../state/selectors/PharmGKB.selectors";
import { PharmGKBGeneType } from "../../../componentTypes/PharmGKBGeneType";

const PharmGKBCard = ({ card, result, data }) => {
  const isDisabled = !Object.keys(data || {}).length;
  return (
    <CardWrapper {...card} card={card} isDisabled={isDisabled}>
      {result ? (
        <>
          {result?.guidelines > 0 && (
            <div>
              {"Guidelines: "}
              <b data-testid="pharmgkb-card-guidelines">{result.guidelines}</b>
            </div>
          )}
          {result?.drugs > 0 && (
            <div>
              {"Drugs: "}
              <b data-testid="pharmgkb-card-drugs">{result.drugs}</b>
            </div>
          )}
        </>
      ) : null}
    </CardWrapper>
  );
};

PharmGKBCard.propTypes = {
  card: PropTypes.instanceOf(Card).isRequired,
  data: PharmGKBGeneType,
  result: PropTypes.shape({
    drugs: PropTypes.number,
    guidelines: PropTypes.number,
  }),
};

PharmGKBCard.defaultProps = {
  data: null,
  result: null,
};

const mapStateToProps = (state) => ({
  result: getPharmGKBDrugs(state),
  data: getPharmGKBData(state),
});

export default connect(mapStateToProps)(PharmGKBCard);
